module.exports = __webpack_public_path__ + "static/img/far4.d39d847e.png";